import Post from 'actions/post';

export default Post.createReducer();